import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { applyTheme, storedTheme } from './lib/theme';

applyTheme(storedTheme());
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
